export function stripTags(str: string) {
  if (!str) return '';
  return str.replace(/<[^>]*>/g, ' ');
}

export function escapeTags(str: string) {
  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
